import ParamsParser from '@videsk/params-parser';
import router from '../../plugins/vue-router';
import i18n from '../../plugins/i18n';

const state = {
  user: {
    firstname: '',
    lastname: '',
    email: '',
    lang: '',
  },
  id: null,
  account: null,
  owner: null,
  table: {
    filterConfirm: i18n.t('words.filter', { extra: '' }),
    filterReset: i18n.t('words.reset', { extra: '' }),
    emptyText: i18n.t('words.empty', { extra: '' }),
  },
  datepicker: {
    start: new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    end: new Date(new Date().setHours(23, 59, 59, 59)).getTime(),
  },
};

const mutations = {
  firstname(state, value) {
    state.user.firstname = value;
  },
  lastname(state, value) {
    state.user.lastname = value;
  },
  email(state, value) {
    state.user.email = value;
  },
  lang(state, value) {
    state.user.lang = value;
  },
  id(state, value) {
    state.id = value;
  },
  account(state, value) {
    state.account = value;
  },
  owner(state, value) {
    state.owner = value;
  },
  start(state, value) {
    state.datepicker.start = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  },
  end(state, value) {
    state.datepicker.end = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(23, 59, 59, 59)).getTime();
  },
};

const actions = {
  toPage({}, name) {
    router.push({ name });
  },
  getUserData({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      dispatch('users/find', state.id, { root: true })
        .then(({
          firstname, lastname, email, lang,
        }) => {
          commit('firstname', firstname);
          commit('lastname', lastname);
          commit('email', email);
          commit('lang', lang);
          resolve();
        })
        .catch(e => reject(new Error(e)));
    });
  },
  filterUser({ dispatch, rootGetters }, level) {
    dispatch('privileges/get', `?level=${level}`, { root: true })
      .then(() => {
        console.log(rootGetters['privileges/data']);
      })
      .catch();
  },
  parseFetchTable({}, objTable) {
    // Function for return parsed skip key
    const parsePage = (limit = 10, page = 0) => ({
      $skip: limit * ((page === 0) ? page : page - 1),
    });
    // Function for return parsed sort key
    const parseSort = (key = '_id', sort = 'ascend') => ({ [`$sort[${key}]`]: (sort === 'ascend') ? 1 : -1 });
    // Start ParamsParse
    const parser = new ParamsParser();
    const obj = { ...objTable };
    const sort = (typeof objTable.sortField !== 'undefined') ? parseSort(objTable.sortField, objTable.sortOrder) : {};
    const limit = parsePage(objTable.results, objTable.page);
    // Delete unnecessary keys
    delete obj.sortOrder;
    delete obj.sortField;
    delete obj.results;
    delete obj.page;
    // If is array
    Object.keys(obj).map(v => (Array.isArray(obj[v]))
      && delete Object.assign(obj, {
        [(v.includes('[$in]')) ? v : `${v}[$in]`]: obj[v],
      })[v]);
    parser.byObj({ ...sort, ...limit, ...obj });
    return parser.parse();
  },
  FillForm({ rootGetters }, { values, getters }) {
    return new Promise((resolve) => {
      const obj = {};
      const data = (typeof getters === 'string') ? rootGetters[getters] : getters;
      Object.keys(values).map(key => obj[key] = data[key] || '');
      resolve(obj);
    });
  },
};

const getters = {
  name: state => state.name,
  id: state => state.id,
  account: state => state.account,
  table_locale: state => state.table,
  start: state => state.datepicker.start,
  end: state => state.datepicker.end,
  firstname: state => state.user.firstname,
  lastname: state => state.user.lastname,
  email: state => state.user.email,
  lang: state => state.user.lang,
  user: state => state.user,
  owner: state => state.owner,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
